import { gql, MutationResult, useMutation } from '@apollo/client';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useCallback } from 'react';
import { MAYA_GRAPHQL_ENDPOINT } from 'basics/constants/common.constants';
import { MutationReturnType } from 'basics/types/maya.types';
import { extractApolloErrorDetails } from 'services/graphql/extractApolloErrorDetails';
import Logger from 'services/logger';

export const setCepStatusToDeletedMutationCall = gql`
  mutation setCepStatusToDeleted($id: String!, $sendToVeeva: Boolean!) {
      setCepStatusToDeleted(id: $id, sendToVeeva: $sendToVeeva)
  }
`;

type ApiResultType = {
  setCepStatusToDeleted: boolean;
};

type UseSetCepStatusToDeletedMutation = [
  (
    id: string,
    sendToVeeva?: boolean
  ) => Promise<MutationReturnType<boolean>>,
  MutationResult<ApiResultType>,
];

export const useSetCepStatusToDeletedMutation = (): UseSetCepStatusToDeletedMutation => {
  const [setCepStatusToDeleted, state] = useMutation<ApiResultType>(setCepStatusToDeletedMutationCall, {
    fetchPolicy: 'network-only',
    context: { clientName: MAYA_GRAPHQL_ENDPOINT },
  });
  const flags = useFlags();

  const executeMutation = useCallback(async (id, sendToVeeva = true) => {
    try {
      const { data } = await setCepStatusToDeleted({
        variables: {
          id,
          sendToVeeva: flags.mayaEnableVeevaBiogenlinc1816 && sendToVeeva,
        },
      });

      return { data: !!data?.setCepStatusToDeleted, error: null };
    } catch (error: unknown) {
      if (error instanceof Error) {
        const customContext = extractApolloErrorDetails(error);
        Logger.logError({
          error,
          customContext,
          transactionName: 'setCepStatusToDeleted.ts - useSetCepStatusToDeletedMutation',
        });

        return { data: false, error: customContext.message as string };
      }

      return { data: false, error: null };
    }
  }, [setCepStatusToDeleted, flags.mayaEnableVeevaBiogenlinc1816]);

  return [executeMutation, state];
};
